import { c as _c } from "react/compiler-runtime";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
export interface MenuItemProps {
  icon: React.ElementType;
  label: string;
  onClick?: () => void;
  selected?: boolean;
  variant?: "default" | "danger";
  endIcon?: React.ReactNode;
}
export const MenuItem = t0 => {
  const $ = _c(20);
  const {
    icon: Icon,
    label,
    onClick,
    selected,
    variant: t1,
    endIcon
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t2 = selected && "bg-muted";
  const t3 = variant === "danger" && "text-red-600 focus:text-red-600 focus:bg-red-100 dark:hover:bg-red-900/50 dark:hover:text-red-400 hover:text-red-600";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = cn("rounded-lg cursor-pointer flex items-center group h-8 px-2", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = variant === "danger" && "group-hover:text-red-600 dark:group-hover:text-red-400";
  let t6;
  if ($[3] !== t5) {
    t6 = cn("w-3.5 h-3.5 mr-2", t5);
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== Icon || $[6] !== t6) {
    t7 = <Icon className={t6} />;
    $[5] = Icon;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== label) {
    t8 = <span className="text-sm">{label}</span>;
    $[8] = label;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== endIcon || $[11] !== selected || $[12] !== variant) {
    t9 = endIcon && <span className={cn("ml-auto", typeof selected === "boolean" && !selected && "text-muted-foreground/50", variant === "danger" && "group-hover:text-red-600 dark:group-hover:text-red-400")}>{endIcon}</span>;
    $[10] = endIcon;
    $[11] = selected;
    $[12] = variant;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onClick || $[15] !== t4 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <DropdownMenuItem onClick={onClick} className={t4}>{t7}{t8}{t9}</DropdownMenuItem>;
    $[14] = onClick;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};